import jquery from "jquery";

window.$ = jquery;

$(document).ready(function() {


    //заводим переменную для хранения аякс запроса,
    //для возможности отмены запроса
    let currentRequest = null;

    // сохраняем начальный урл
    let rootState = {
        el: 'root',
        title : $('title').text(),
        url : window.location.href
    };

    // управляем сменой тайтлов и урлов
    const historyWriter = function(state) {
        history.pushState({'el': state.el}, state.title, state.url);
        loadHistoryState({el: state.el, url: state.url});
    };


    window.onpopstate = function(event) {

        if (event.state) {
            loadHistoryState({el: event.state.el, url: document.location});
        }
    };


    // слушаем клики по ссылкам меню
    $('body').on('click', 'a.navLinks', function(event) {
        event.preventDefault();

        let a = $(this);
        let li = a.parent();

        if (li.hasClass('active')) {
            return false;
        }

        li.siblings('.active').removeClass('active');
        li.addClass('active');

        // тайтл для новой страницы - берем название категории
        let title = 'IG Trend';
        if (a.parents('.menu_main').length > 0) {
            title = a.html() + ' — IG Trend';
        } else {
            title = $('.menu_main').find('.active').children('a').html() + ' — IG Trend';
        }

        let navState = {
            el: 'nav',
            title: title,
            url: a.attr('href')
        };
        historyWriter(navState);

        return false;
    });


    // переключатор брэнда
    $('body').on('change', "#brandSelect", function() {
        // тайтл для новой страницы - берем название категории
        let title = 'IG Trend';

        title = $('.menu_main').find('.active').children('a').html() + ' — IG Trend';

        let $url = window.location.pathname;
        let $params = window.location.search.substr(1).replace(/(\&)?brand=(\d+)/gi, '');

        let navState = {
            el: 'nav',
            title: title,
            url: $url + '?' + $params + '&brand=' + $(this).val()
        };
        historyWriter(navState);

        return false;
    });


    // переключатор сортировки
    $('body').on('change', "select[name=sort]", function() {
        // тайтл для новой страницы - берем название категории
        let title = 'IG Trend';

        title = $('.menu_main').find('.active').children('a').html() + ' — IG Trend';

        let $url = window.location.pathname;
        let $params = window.location.search.substr(1).replace(/(\&)?sort=(\w+)/gi, '');

        let navState = {
            el: 'nav',
            title: title,
            url: $url + '?' + $params + '&sort=' + $(this).val()
        };
        historyWriter(navState);

        return false;
    });




    // TO TOP
    const menuBottom = $("#menu").offset().top + $("#menu").height();

    toTop();

    $(document).scroll(function () {
        toTop();
    });

    $('a[href^="#"]').on('click', function (event) {
        const target = $(this.getAttribute('href'));
        if (target.length) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top
            }, 500);
        }
    });

    function toTop() {
        const documentTop = $(document).scrollTop();

        if (documentTop > menuBottom) {
            $("#up").fadeIn();
        } else {
            $("#up").fadeOut();
        }
    }

    function loadHistoryState(state) {

        // $('#fader').hide();

        if (state.el === "nav") {
            shelfsNav(state.url);
        } else if (state.el === "root") {
            if (state.url === rootState.url) {
                $("#item_page").slideUp(function(){
                    $("#item_page").remove();
                });
            } else {
                shelfsNav(state.url);
            }
        } else {
            const item = $('a[href="' + state.url + '"]');
            toggleItem(item);
        }
    }

    // аякс навигация
    function shelfsNav(url) {
        // spinner.spin(document.getElementById('spin'));

        $('.body').load(
            url + ' .main-container',
            function() {
                // spinner.stop();

                rootState.title = $('.menu_main').find('.active').children('a').html() + ' — IG Trend';
                rootState.url = url;
            }
        );
    }
});